// ============================================================================
// PORTUGUESE TRANSLATIONS - CHAPTER 6: AS MISSÕES DE PAULO
// ============================================================================
// Níveis 66-78 (13 níveis, 39 questões)

export const chapter6Translations = {
  name: "As Missões de Paulo",
  description: "Até aos confins da terra...",
  
  spiritualWisdom: {
    principle: "O Evangelho é para todas as nações e deve ser anunciado ao mundo inteiro",
    scripture: "Ide e fazei discípulos de todas as nações (Mateus 28:19)",
    application: "Cada cristão é chamado a ser testemunha de Cristo onde Deus o coloca"
  },
  
  levels: {
    66: {
      name: "Primeira Viagem Missionária",
      challenge: "Separai-me a Barnabé e a Saulo para a obra a que os tenho chamado...",
      easy: {
        question: "Quem acompanhou Paulo na sua primeira viagem?",
        options: ["Pedro", "Barnabé", "Silas", "Timóteo"],
        hint: "O 'filho de consolação'",
        funFact: "👥 Barnabé tinha acolhido Paulo após a sua conversão - parceria providencial!"
      },
      medium: {
        question: "De que cidade partiram para a sua missão?",
        options: [
          "Jerusalém",
          "Antioquia da Síria",
          "Tarso",
          "Damasco"
        ],
        hint: "A primeira igreja mista de judeus e gentios",
        funFact: "🚢 Antioquia: porto de partida da evangelização do mundo ocidental!"
      },
      hard: {
        question: "O que revela esta primeira viagem sobre a estratégia missionária?",
        options: [
          "É preciso ficar na sua região",
          "O Evangelho transcende todas as fronteiras culturais",
          "Só os judeus podem ser salvos",
          "A missão é facultativa"
        ],
        hint: "Trata-se da universalidade da mensagem",
        funFact: "🌊 Atravessar o Mediterrâneo = dar o passo para a evangelização mundial!"
      }
    },
    
    67: {
      name: "Em Chipre com Elimas",
      challenge: "Ó homem cheio de todo o engano e de toda a malícia, filho do diabo...",
      easy: {
        question: "Que mago se opôs a Paulo em Chipre?",
        options: ["Simão", "Elimas", "Apolo", "Alexandre"],
        hint: "Um falso profeta que queria afastar o procônsul",
        funFact: "🪄 Primeiro confronto direto entre o Evangelho e a magia!"
      },
      medium: {
        question: "O que fez Paulo a Elimas para o castigar?",
        options: [
          "Expulsou-o",
          "Cegou-o temporariamente",
          "Ignorou-o",
          "Debateu com ele"
        ],
        hint: "Uma cegueira temporária para lhe abrir os olhos espirituais",
        funFact: "👁️ Ironia divina: aquele que cegava as almas fica temporariamente cego!"
      },
      hard: {
        question: "Como ilustra este episódio o poder do Evangelho?",
        options: [
          "A violência é necessária",
          "A verdade divina impõe-se perante a mentira",
          "É preciso combater todos os magos",
          "Paulo era vingativo"
        ],
        hint: "Trata-se da autoridade divina perante a impostura",
        funFact: "⚡ O procônsul crê ao ver o poder divino - demonstração eficaz!"
      }
    },

    68: {
      name: "Em Antioquia da Pisídia",
      challenge: "A vós convinha que a palavra de Deus fosse primeiramente anunciada...",
      easy: {
        question: "Onde pregava Paulo ao chegar a uma cidade?",
        options: [
          "Na praça pública",
          "Primeiro na sinagoga",
          "Nas casas dos ricos",
          "Nos templos pagãos"
        ],
        hint: "Começava sempre pelo seu povo",
        funFact: "🕍 Estratégia missionária: primeiro aos judeus, depois aos gentios!"
      },
      medium: {
        question: "Como reagiram os judeus à mensagem de Paulo?",
        options: [
          "Todos a aceitaram",
          "Ficaram divididos: alguns creram, outros opuseram-se",
          "Permaneceram indiferentes",
          "Expulsaram-no imediatamente"
        ],
        hint: "Divisão clássica perante o Evangelho",
        funFact: "⚖️ O Evangelho divide sempre: aceitação ou rejeição, não há indiferença!"
      },
      hard: {
        question: "Por que Paulo se volta para os gentios?",
        options: [
          "Preferia os gentios",
          "A rejeição dos judeus abre a porta às nações",
          "Era mais fácil",
          "Abandonava a sua missão"
        ],
        hint: "Trata-se do cumprimento profético",
        funFact: "🚪 'Luz das nações' - profecia de Isaías cumprida por Paulo!"
      }
    },

    69: {
      name: "Cura em Listra",
      challenge: "Os deuses desceram até nós em forma de homens!",
      easy: {
        question: "O que curou Paulo em Listra?",
        options: [
          "Um cego",
          "Um paralítico de nascença",
          "Um surdo-mudo",
          "Um leproso"
        ],
        hint: "Alguém que nunca tinha andado",
        funFact: "🦵 Milagre espetacular: 'Levanta-te direito sobre os teus pés!' - fé curadora!"
      },
      medium: {
        question: "Por quem tomou a multidão Paulo e Barnabé?",
        options: [
          "Reis",
          "Deuses (Júpiter e Mercúrio)",
          "Magos",
          "Profetas"
        ],
        hint: "Divindades do panteão grego",
        funFact: "⚡ Barnabé = Júpiter (imponente), Paulo = Mercúrio (orador) - mal-entendido cultural!"
      },
      hard: {
        question: "Como reagiu Paulo a esta adoração idólatra?",
        options: [
          "Aceita as honras",
          "Rasga as suas vestes e prega o Deus verdadeiro",
          "Cala-se por cortesia",
          "Aproveita a situação"
        ],
        hint: "Rejeição total da idolatria",
        funFact: "👔 Rasgar as vestes = horror judaico perante a idolatria - integridade total!"
      }
    },

    70: {
      name: "Lapidação e Ressurreição",
      challenge: "Rodeando-o os discípulos, levantou-se e entrou na cidade...",
      easy: {
        question: "O que fizeram os habitantes de Listra a Paulo?",
        options: [
          "Aprisionaram-no",
          "Apedrejaram-no",
          "Exilaram-no",
          "Crucificaram-no"
        ],
        hint: "O castigo tradicional judaico",
        funFact: "🪨 De 'deus' a 'morto' num dia - inconstância da multidão humana!"
      },
      medium: {
        question: "O que fez Paulo depois de ser apedrejado?",
        options: [
          "Fugiu da cidade",
          "Escondeu-se",
          "Levantou-se e voltou a entrar na cidade",
          "Foi ao hospital"
        ],
        hint: "Coragem sobrenatural após a morte suposta",
        funFact: "💪 Ressurreição milagrosa ou cura divina - coragem incrível!"
      },
      hard: {
        question: "O que revela esta perseguição sobre o custo do testemunho?",
        options: [
          "É preciso evitar conflitos",
          "Testemunhar por Cristo pode custar a vida",
          "Paulo era imprudente",
          "A perseguição é inútil"
        ],
        hint: "Trata-se do preço do testemunho autêntico",
        funFact: "✝️ 'Por muitas tribulações nos importa entrar' - realismo de Paulo!"
      }
    },

    71: {
      name: "O Concílio de Jerusalém",
      challenge: "Se não vos circuncidardes, não podeis ser salvos...",
      easy: {
        question: "Que debate importante teve lugar no concílio de Jerusalém?",
        options: [
          "O batismo",
          "A circuncisão dos gentios convertidos",
          "O dia do sábado",
          "As ofertas"
        ],
        hint: "Era preciso tornar-se judeu para ser cristão?",
        funFact: "✂️ Primeira crise importante: cristianismo ou judeo-cristianismo?"
      },
      medium: {
        question: "Qual foi a decisão final do concílio?",
        options: [
          "Circuncisão obrigatória",
          "Liberdade para os gentios com algumas recomendações",
          "Separação total dos judeus",
          "Adiamento da decisão"
        ],
        hint: "Abertura aos gentios sem restrição maior",
        funFact: "🆓 Revolução histórica: o Evangelho livre da lei mosaica!"
      },
      hard: {
        question: "Que importância tem este concílio para a Igreja universal?",
        options: [
          "Acontecimento menor",
          "Estabelece a universalidade da salvação pela fé somente",
          "Divide a Igreja",
          "Reforça o legalismo"
        ],
        hint: "Trata-se do fundamento da Igreja universal",
        funFact: "🌍 Sem esta decisão, o cristianismo teria permanecido uma seita judaica!"
      }
    },

    72: {
      name: "Segunda Viagem: Timóteo",
      challenge: "Paulo quis levá-lo consigo e circuncidou-o por causa dos judeus...",
      easy: {
        question: "Quem se juntou a Paulo como jovem colaborador?",
        options: ["Marcos", "Lucas", "Timóteo", "Tito"],
        hint: "O 'filho amado' de Paulo",
        funFact: "👦 Timóteo: jovem prodígio tornado braço direito de Paulo - mentoria bem-sucedida!"
      },
      medium: {
        question: "Por que Paulo circuncidou Timóteo apesar da liberdade adquirida?",
        options: [
          "Por obrigação legal",
          "Por estratégia missionária junto dos judeus",
          "Por tradição",
          "Por erro"
        ],
        hint: "Sabedoria prática para evitar obstáculos",
        funFact: "🎯 Liberdade com sabedoria: 'Fazer-me tudo para todos para ganhar alguns'!"
      },
      hard: {
        question: "Como ilustra esta atitude a flexibilidade missionária?",
        options: [
          "Paulo era inconstante",
          "Adaptava o seu método sem comprometer o Evangelho",
          "Cedia à pressão",
          "Era hipócrita"
        ],
        hint: "Trata-se de sabedoria contextual",
        funFact: "⚖️ Princípios firmes, métodos flexíveis - arte do testemunho eficaz!"
      }
    },

    73: {
      name: "A Visão do Homem Macedónio",
      challenge: "Passa à Macedónia e ajuda-nos!",
      easy: {
        question: "O que viu Paulo na sua visão noturna?",
        options: [
          "Um anjo",
          "Um homem da Macedónia chamando-o",
          "Jesus falando-lhe",
          "Uma grande luz"
        ],
        hint: "Um pedido de ajuda vindo da Europa",
        funFact: "🌉 Visão decisiva: o Evangelho atravessa para a Europa - viragem histórica!"
      },
      medium: {
        question: "Qual foi a primeira cidade europeia evangelizada?",
        options: [
          "Atenas",
          "Corinto",
          "Filipos",
          "Tessalónica"
        ],
        hint: "Colónia romana na Macedónia",
        funFact: "🏛️ Filipos: primeira igreja europeia - continente transformado para sempre!"
      },
      hard: {
        question: "O que simboliza esta visão para a história do cristianismo?",
        options: [
          "Um sonho ordinário",
          "A expansão providencial para o Ocidente",
          "Uma alucinação",
          "Uma mudança de plano"
        ],
        hint: "Trata-se da Providência dirigindo a história",
        funFact: "🗺️ Sem esta visão, a Europa poderia ter permanecido pagã - plano divino!"
      }
    },

    74: {
      name: "Lídia, Primeira Convertida Europeia",
      challenge: "O Senhor abriu o coração de Lídia para que estivesse atenta...",
      easy: {
        question: "Qual era o ofício de Lídia?",
        options: [
          "Padeira",
          "Vendedora de púrpura",
          "Tecelã",
          "Oleira"
        ],
        hint: "Comércio de luxo da época",
        funFact: "🟣 Púrpura = cor real muito cara - Lídia era próspera!"
      },
      medium: {
        question: "Onde Paulo encontrou Lídia?",
        options: [
          "No mercado",
          "À beira do rio durante uma oração",
          "Em sua casa",
          "Na sinagoga"
        ],
        hint: "Um lugar de oração ao ar livre",
        funFact: "🏞️ Não havia sinagoga em Filipos - oração à beira da água segundo a tradição!"
      },
      hard: {
        question: "O que revela a conversão de Lídia sobre a obra divina?",
        options: [
          "Estava predisposta",
          "Deus abre os corações preparados para receber a sua Palavra",
          "Foi uma coincidência",
          "Paulo era persuasivo"
        ],
        hint: "Trata-se da ação divina na conversão",
        funFact: "💝 'O Senhor abriu o seu coração' - Deus prepara e abre as almas!"
      }
    },

    75: {
      name: "Prisão em Filipos",
      challenge: "Pela meia-noite, Paulo e Silas oravam e cantavam hinos a Deus...",
      easy: {
        question: "Por que Paulo e Silas foram presos?",
        options: [
          "Roubo",
          "Perturbação da ordem pública expulsando um demónio",
          "Blasfémia",
          "Revolta"
        ],
        hint: "Cura de uma escrava adivinha",
        funFact: "💸 Libertar uma alma custa caro aos seus exploradores - perseguição económica!"
      },
      medium: {
        question: "O que fizeram Paulo e Silas na prisão?",
        options: [
          "Queixaram-se",
          "Oravam e cantavam",
          "Preparavam a sua defesa",
          "Dormiram"
        ],
        hint: "Louvor apesar das correntes",
        funFact: "🎵 Cânticos de louvor à meia-noite na prisão - fé inabalável que impressiona!"
      },
      hard: {
        question: "Como transformou a sua atitude a situação?",
        options: [
          "Não teve efeito",
          "Converteu o carcereiro após o terremoto",
          "Irritou os guardas",
          "Deixou-os loucos"
        ],
        hint: "Testemunho poderoso pelo exemplo",
        funFact: "🌍 Terremoto + testemunho = conversão do carcereiro e da sua família!"
      }
    },

    76: {
      name: "Em Atenas: O Areópago",
      challenge: "O que vós adorais sem o conhecer, isso vos anuncio eu...",
      easy: {
        question: "A que altar Paulo fez referência em Atenas?",
        options: [
          "Ao deus Zeus",
          "Ao deus desconhecido",
          "A Apolo",
          "A Atena"
        ],
        hint: "Uma inscrição misteriosa que serviu de ponto de partida",
        funFact: "🏛️ 'Ao deus desconhecido' - ponto de contacto genial com a filosofia grega!"
      },
      medium: {
        question: "Perante quem pregou Paulo em Atenas?",
        options: [
          "A multidão comum",
          "Os filósofos epicureus e estoicos no Areópago",
          "Os sacerdotes dos templos",
          "O imperador romano"
        ],
        hint: "A elite intelectual grega",
        funFact: "🧠 Areópago = Harvard antiga - Paulo perante os maiores pensadores!"
      },
      hard: {
        question: "Qual foi a reação dos atenienses à ressurreição?",
        options: [
          "Aceitação unânime",
          "Divisão: zombaria de alguns, interesse de outros",
          "Ira geral",
          "Indiferença total"
        ],
        hint: "Reação típica dos intelectuais a este mistério",
        funFact: "🤔 Ressurreição = pedra de tropeço para a inteligência humana orgulhosa!"
      }
    },

    77: {
      name: "Corinto: Paulo Fabricante de Tendas",
      challenge: "Ficou com eles e trabalhava, pois eram fabricantes de tendas...",
      easy: {
        question: "Que ofício praticava Paulo para ganhar a vida?",
        options: [
          "Pescador",
          "Fabricante de tendas",
          "Escriba",
          "Comerciante"
        ],
        hint: "Ofício manual que tinha aprendido",
        funFact: "⛺ Paulo: apóstolo-artesão - dignidade do trabalho manual entre os cristãos!"
      },
      medium: {
        question: "Em casa de quem Paulo ficou em Corinto?",
        options: [
          "Numa hospedaria",
          "Em casa de Áquila e Priscila",
          "Em casa do governador",
          "Na sinagoga"
        ],
        hint: "Um casal de fabricantes de tendas como ele",
        funFact: "👫 Áquila e Priscila: casal missionário modelo - hospitalidade cristã!"
      },
      hard: {
        question: "Por que Paulo trabalhava com as suas mãos?",
        options: [
          "Só por necessidade financeira",
          "Para não ser um peso e autenticar o seu testemunho",
          "Por tradição familiar",
          "Porque amava esse ofício"
        ],
        hint: "Trata-se de independência e credibilidade",
        funFact: "💼 Autonomia financeira = liberdade de palavra - Paulo não dependia de ninguém!"
      }
    },

    78: {
      name: "Revolta em Éfeso",
      challenge: "Grande é a Diana dos efésios!",
      easy: {
        question: "Quem provocou a revolta contra Paulo em Éfeso?",
        options: [
          "As autoridades romanas",
          "Demétrio o ourives e os artesãos",
          "Os filósofos",
          "Os sacerdotes judeus"
        ],
        hint: "Os que fabricavam templos de Diana",
        funFact: "🏛️ Primeira greve da história: o Evangelho ameaça a economia idólatra!"
      },
      medium: {
        question: "Quanto tempo Paulo ensinou em Éfeso?",
        options: [
          "6 meses",
          "1 ano",
          "2 anos",
          "3 anos"
        ],
        hint: "A sua estadia missionária mais longa",
        funFact: "📅 3 anos de ensino intensivo - Éfeso tornou-se centro missionário importante!"
      },
      hard: {
        question: "O que revela esta revolta sobre o impacto social do Evangelho?",
        options: [
          "O Evangelho não muda nada",
          "Transforma as estruturas económicas e sociais",
          "Só diz respeito à religião",
          "Evita conflitos"
        ],
        hint: "Trata-se de transformação social profunda",
        funFact: "💰 Quando o Evangelho progride, os ídolos perdem o seu mercado - impacto económico!"
      }
    }
  }
};

export default chapter6Translations;
